module.exports = __webpack_public_path__ + "img/Dash_mini_open_new.219eeb67.svg";